// extracted by mini-css-extract-plugin
export default {"danger":"Danger_danger__5X5rX","danger__message":"Danger_danger__message__E5hxP","danger__button":"Danger_danger__button__cUHFI"};